import { render, staticRenderFns } from "./agentBgdRecharge.vue?vue&type=template&id=c9c4e180&scoped=true&"
import script from "./agentBgdRecharge.vue?vue&type=script&lang=js&"
export * from "./agentBgdRecharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c4e180",
  null
  
)

export default component.exports